import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { UseImage } from "./";
// import Loading_Overlay from "assets/DOC/img/Loading_DS.gif";
import Loading_Overlay from "assets/Loading_Overlay.gif";

const useStyles = makeStyles((theme) => ({
  dialogGralLoad: {
    zIndex: "90000 !important",
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        backgroundColor: "#FFFFFF !important",
      },
      "& .MuiPaper-elevation24": {
        boxShadow: "none",
      },
    },
    "& .MuiDialogContent-root:first-child": {
      overflow: "hidden !important",
    },
  },
  DialogContent: {
    maxWidth: "600px !important",
    backgroundColor: "transparent  !important",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    alignItems: "center",
    zIndex: "90000 !important",
    width: "300px !important",
    height: "30vh",
    overflow: "hidden",
    [theme.breakpoints.only("xs")]: {
      minWidth: "250px !important",
      width: "250px !important",
      height: "30vh",
    },
    [theme.breakpoints.only("sm")]: {
      minWidth: "250px !important",
      width: "250px !important",
      height: "30vh",
    },
    [theme.breakpoints.only("md")]: {
      minWidth: "250px !important",
      width: "250px !important",
      height: "35vh",
    },
    "& .MuiDialogContent-root:first-child": {
      overflow: "hidden !important",
    },
  },
  DialogActions: {
    justifyContent: "center !important",
    zIndex: "90000 !important",
  },
  imgLoad: {
    width: "90% !important",
    padding: "8px",
    [theme.breakpoints.only("xs")]: {
      width: "90% !important",
    },
    [theme.breakpoints.only("sm")]: {
      width: "90% !important",
    },
    [theme.breakpoints.only("md")]: {
      width: "90% !important",
    },
    zIndex: "92000 !important",
  },
}));

export const CustomLoadingOverlay = (props) => {
  // const theme = useTheme()
  // const location = useLocation()
  const classes = useStyles();

  // let watchAnimationData = require('../assets/Loader.json')
  // const renderer = 'svg'
  // const rendererSettings = {
  //     preserveAspectRatio: 'xMinYMin slice',
  //     width: '30%',
  //     //   className: localStyles.lottieImgColor,
  // }

  return (
    <Dialog
      onClose={props.closeAction}
      open={props.active}
      className={classes.dialogGralLoad}
    >
      <DialogContent className={classes.DialogContent}>
        <UseImage
          type="Image"
          src={Loading_Overlay}
          className={classes.imgLoad}
        />
      </DialogContent>
      <DialogActions className={classes.DialogActions}>
        <Typography variant="subtitle2" gutterBottom>
          {props.text}
        </Typography>
      </DialogActions>
    </Dialog>
  );
};
